import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=56cfd6ec&scoped=true&"
import script from "./Unavailable.vue?vue&type=script&lang=ts&"
export * from "./Unavailable.vue?vue&type=script&lang=ts&"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=56cfd6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfd6ec",
  null
  
)

export default component.exports